import React from "react";
import mvvLogo from "../assets/cms-mvv-logo.png";

function CmsShellHeader() {
  return (
    <header className="cms-website-shell-header">
      <div className="cms-website-shell-header__brand">
        <img
          src={mvvLogo}
          alt="MyVitalView"
          className="cms-website-shell-header__logo"
          width={160}
          height={40}
        />
      </div>
      <div className="cms-website-shell-header__content">
        <h1 className="cms-website-shell-header__title">Website Content Management</h1>
        <p className="cms-website-shell-header__description">
          Edit marketing pages, navigation, SEO, and bilingual content. Changes publish live.
        </p>
      </div>
      <div className="cms-website-shell-header__aside" aria-label="Publishing status">
        <span className="cms-website-shell-header__badge cms-website-shell-header__badge--live">
          Live publish
        </span>
        <span className="cms-website-shell-header__langs">EN · ES</span>
      </div>
    </header>
  );
}

export default CmsShellHeader;
